import React from 'react';
import { Send } from '@saleshandy/icons';

const PurpleSend = () => (
  <Send width={16} height={16} className="purple-txt-16" />
);

export default PurpleSend;
